module.exports = __webpack_public_path__ + "static/media/personOne.d14abc96.jfif";